export function errToMessage(msg: unknown): string {
  if (typeof msg === 'string') {
    return msg
  }

  if (msg instanceof Error) {
    return msg.message
  }

  return 'An error has occurred'
}
